import { React, useState, useEffect, useContext, useRef } from 'react';
import UserContext from '../../components/User_Context.js';
import * as menu from "../../assets/menus/menu.js";
import * as api from "../../api/apiConnector.js";
import Loader from '../../components/ui/loader.js';
import userSvg from '../../assets/icon/userAndGroups/user.svg';
import groupSvg from '../../assets/icon/userAndGroups/group.svg'
import { useTranslation } from 'react-i18next';

import Swal from 'sweetalert2';
import DataTable from 'datatables.net-dt';
import 'datatables.net-dt/css/dataTables.dataTables.css'; // stile base


function Users_Groups_Search_Screen(params) {
    const { currentUser } = useContext(UserContext);
    const [searchList, setSearchList] = useState(null);
    const { t } = useTranslation('labels');
    const tableContainerRef = useRef(null);
    const dataTableRef = useRef(null);

    //#region label

    //#endregion

    useEffect(() => {
        const writeMenu = async () => {
            await menu.write({ user: currentUser() });
        };
        writeMenu();
    }, [currentUser]);

    // Cleanup DataTable on component unmount
    useEffect(() => {
        return () => {
            if (dataTableRef.current) {
                try {
                    dataTableRef.current.destroy(true);
                } catch (e) {
                    console.warn('Error destroying DataTable on unmount:', e);
                }
                dataTableRef.current = null;
            }
        };
    }, []);


    useEffect(() => {
        if (!searchList || !tableContainerRef.current) return;

        // Destroy existing DataTable
        if (dataTableRef.current) {
            try {
                dataTableRef.current.destroy();
                dataTableRef.current = null;
            } catch (e) {
                console.warn('Error destroying DataTable:', e);
            }
        }

        // Clear container
        tableContainerRef.current.innerHTML = '';

        // Build table HTML manually
        const items = getItems();
        let tableHTML = `
            <table id="empoloyeestbl2" class="table">
                <thead>
                    <tr>
                        <th>${t('name', { ns: 'labels' })}</th>
                        <th>${t('lastName', { ns: 'labels' })}</th>
                        <th>${t('email', { ns: 'labels' })}</th>
                        <th>${t('username', { ns: 'labels' })}</th>
                    </tr>
                </thead>
                <tbody>`;

        items.forEach((item) => {
            const iconSrc = item.type === "user" ? userSvg : groupSvg;
            tableHTML += `
                <tr data-id="${item.item.Id}" data-type="${item.type}" style="cursor: pointer;">
                    <td class="col-3">
                        <img width="28" height="28" src="${iconSrc}" alt="icon" class="me-4" />
                        ${item.item.Name || ''}
                    </td>
                    <td class="col-3">${item.item.LastName || ''}</td>
                    <td class="col-3">${item.item.EMail || ''}</td>
                    <td class="col-3">${item.item.UserName || ''}</td>
                </tr>`;
        });

        tableHTML += `
                </tbody>
            </table>`;

        // Insert HTML
        tableContainerRef.current.innerHTML = tableHTML;

        // Add click handlers
        const rows = tableContainerRef.current.querySelectorAll('tbody tr');
        rows.forEach(row => {
            row.addEventListener('click', () => {
                const id = row.getAttribute('data-id');
                const type = row.getAttribute('data-type');
                if (type === "user") {
                    window.location.href = `/admin/user/${id}`;
                } else {
                    window.location.href = `/admin/group/${id}`;
                }
            });
        });

        // Initialize DataTable
        const timer = setTimeout(() => {
            try {
                const table = tableContainerRef.current.querySelector('#empoloyeestbl2');
                if (table) {
                    dataTableRef.current = new DataTable(table, {
                        searching: false,
                     
                        pageLength: 50,
                        language: {
                            paginate: {
                                previous: '<',
                                next: '>'
                            }
                        },
                        pagingType: "simple_numbers",
                        select: false,
                        lengthChange: false,
                    });
                }
            } catch (e) {
                console.error('Error initializing DataTable:', e);
            }
        }, 100);

        return () => {
            clearTimeout(timer);
        };
    }, [searchList, t]);

    const getItems = () => {
        let _groups = searchList.groups.map((i) => {
            return {
                type: "group",
                item: i
            }
        });

        let _users = searchList.users.map((i) => {
            return {
                type: "user",
                item: i
            }
        });

        let _output = [];

        for (var i of _groups) {
            _output.push(i);
        }

        for (var j of _users) {
            _output.push(j);
        }

        return _output;
    }

    const getFilteredUsersGroups = async (name, email, userName, isDisabled) => {
        var result = await api.sendMessage("usersGroups/search", {
            user: currentUser(),
            body: {
                name, email, userName, isDisabled
            }
        })

        return result;
    }
    const searchData = async () => {
        var firstName = window.$("#firstName").val();
        var email = window.$("#email").val();
        var userName = window.$("#userName").val();
        var isDisable = window.$("#isDisabledCheckBox .form-check-input").is(':checked');

        var result = await getFilteredUsersGroups(firstName, email, userName, isDisable);

        if(result.success){
            setSearchList(result.filtered);
        }
        else{
            Swal.fire({
                title: t('error', { ns: 'labels' }),
                icon: "error",
                text: t(result.message.toLowerCase(), { ns: 'labels' }),
                showConfirmButton: true,
                allowOutsideClick: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    window.location.reload();
                }
            });
        }
        window.$("#tableSearchDiv").prop("hidden", null);
    }


    return (
        <>
            <div className="page-titles">
                <ol className="breadcrumb">
                    <li><h5 className="bc-title">{t('userGroupFinder', { ns: 'labels' })}</h5></li>
                    <li className="breadcrumb-item"><button style={{background: "none", border: "none", padding: 0, font: "inherit", cursor: "pointer", color: "blue", textDecoration: "underline"}}>
                        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2.125 6.375L8.5 1.41667L14.875 6.375V14.1667C14.875 14.5424 14.7257 14.9027 14.4601 15.1684C14.1944 15.4341 13.8341 15.5833 13.4583 15.5833H3.54167C3.16594 15.5833 2.80561 15.4341 2.53993 15.1684C2.27426 14.9027 2.125 14.5424 2.125 14.1667V6.375Z" stroke="#2C2C2C" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M6.375 15.5833V8.5H10.625V15.5833" stroke="#2C2C2C" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                        {t('home', { ns: 'labels' })} </button>
                    </li>
                    <li className="breadcrumb-item active"><button style={{background: "none", border: "none", padding: 0, font: "inherit", cursor: "pointer", color: "inherit"}}>{t('userGroupFinder', { ns: 'labels' })}</button></li>
                </ol>
            </div>
            <div className="container-fluid" style={{ height: 'calc(100vh - 120px)', overflowY: 'auto', overflowX: 'hidden' }}>
                <div className="row">
                    <div className="col-xl-12 col-lg-12">
                        <div className="card">
                            <div className="card-header">
                                <h4 className="card-title">{t('filter', { ns: 'labels' })}</h4>
                            </div>
                            <div className="card-body">
                                <div className="basic-form">
                                    <div className="row">
                                        <div className="mb-3 col-md-12">
                                            <label className="form-label">{t('name', { ns: 'labels' })}</label>
                                            <input id='firstName' type="text" className="form-control" placeholder={t('name', { ns: 'labels' })} />
                                        </div>
                                        <div className="mb-3 col-md-6">
                                            <label className="form-label">{t('email', { ns: 'labels' })}</label>
                                            <input id='email' type="email" className="form-control" placeholder={t('email', { ns: 'labels' })} />
                                        </div>
                                        <div className="mb-3 col-md-6">
                                            <label className="form-label">{t('username', { ns: 'labels' })}</label>
                                            <input id='userName' type="text" className="form-control" placeholder={t('username', { ns: 'labels' })} />
                                        </div>
                                    </div>

                                    <div className="mb-3" id='isDisabledCheckBox'>
                                        <div className="form-check">
                                            <input className="form-check-input" type="checkbox" />
                                            <label className="form-check-label">
                                                {t('disabled', { ns: 'labels' })}
                                            </label>
                                        </div>
                                    </div>
                                    <button type="submit" className="btn btn-primary" onClick={() => {
                                        searchData();
                                    }}>{t('search', { ns: 'labels' })}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row" id="tableSearchDiv" hidden>
                    <div className="col-xl-12 col-lg-12">
                        <div className="card">
                            <div className="card-body p-0"></div>
                            <div className="table-responsive-lg active-projects task-table">
                                <div className="tbl-caption">
                                    <div className="row">
                                        <div className="col">
                                            <h4 className="heading mb-0 text-start">{t('foundElements', { ns: 'labels' })}</h4>
                                        </div>
                                    </div>
                                </div>
                                <div ref={tableContainerRef}></div>
                                {!searchList && <Loader />}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export { Users_Groups_Search_Screen }